import differenceInMinutes from 'date-fns/differenceInMinutes';
import * as z from 'zod';
import { parseGQLTime } from '../../gqlDate';
export var Reminder = z.object({
    /**
   * Delay before (negative) or after (positive) the meal/snack time to send the reminder.
   */ delay: z.number().int(),
    delayUnit: z.enum([
        'minutes',
        'hours'
    ])
});
export var EatingScheduleItem = z.object({
    /**
   * Time for the meal/snack in the format "HH:MM".
   */ time: z.string(),
    reminders: z.array(Reminder)
});
export var EatingSchedule = z.object({
    meals: z.object({
        breakfast: EatingScheduleItem,
        lunch: EatingScheduleItem,
        dinner: EatingScheduleItem
    }),
    snacks: z.array(EatingScheduleItem).min(1, {
        message: 'Must setup at least one snack'
    })
}).superRefine(function(value, context) {
    var breakfastTime = parseGQLTime(value.meals.breakfast.time);
    var lunchTime = parseGQLTime(value.meals.lunch.time);
    var dinnerTime = parseGQLTime(value.meals.dinner.time);
    for(var i in value.snacks){
        var snack = value.snacks[i];
        var snackTime = parseGQLTime(snack.time);
        if (Math.abs(differenceInMinutes(snackTime, breakfastTime)) < 120 || Math.abs(differenceInMinutes(snackTime, lunchTime)) < 120 || Math.abs(differenceInMinutes(snackTime, dinnerTime)) < 120) {
            context.addIssue({
                code: 'custom',
                path: [
                    'snacks',
                    Number(i),
                    'time'
                ],
                message: 'Snacks should not be within two hours of a meal'
            });
        }
    }
    // At most 1 snack is allowed between each meal
    var breakfastLunch = [];
    var lunchDinner = [];
    var dinnerBreakfast = [];
    for(var i1 = 0; i1 < value.snacks.length; i1++){
        var snackTime1 = parseGQLTime(value.snacks[i1].time);
        if (breakfastTime <= snackTime1 && snackTime1 < lunchTime) {
            breakfastLunch.push(i1);
        } else if (lunchTime <= snackTime1 && snackTime1 < dinnerTime) {
            lunchDinner.push(i1);
        } else if (dinnerTime <= snackTime1 || snackTime1 < breakfastTime) {
            dinnerBreakfast.push(i1);
        } else {
            // should never get here
            throw new Error('Unexpected snack time');
        }
    }
    for(var _i = 0, _iter = [
        breakfastLunch,
        lunchDinner,
        dinnerBreakfast
    ]; _i < _iter.length; _i++){
        var snacksBetweenMeals = _iter[_i];
        if (snacksBetweenMeals.length > 1) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = snacksBetweenMeals.slice(1)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var snackIndex = _step.value;
                    context.addIssue({
                        code: 'custom',
                        path: [
                            'snacks',
                            snackIndex,
                            'time'
                        ],
                        message: 'Only one snack is allowed between each meal'
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
}).prefault({
    meals: {
        breakfast: {
            time: '08:00',
            reminders: []
        },
        lunch: {
            time: '13:00',
            reminders: []
        },
        dinner: {
            time: '19:00',
            reminders: []
        }
    },
    snacks: [
        {
            time: '10:00',
            reminders: []
        },
        {
            time: '16:00',
            reminders: []
        },
        {
            time: '22:00',
            reminders: []
        }
    ]
});
